import {removeChildren} from "./remove-children.js";
import {renderQuestion} from "./render-question.js";
import {renderSuccess} from "./render-success.js";
const memorizedEventListenerReNewer = (element, type) => {
  let previousCallback;
  return (callback) => {
    if (previousCallback) {
      element.removeEventListener(type, previousCallback);
    }
    element.addEventListener(type, callback);
    previousCallback = callback;
  };
};
export const nextQuestionButtonRenderer = (formElement) => {
  const explanationElement = formElement.querySelector(".quiz-form__explanation");
  const nextQuestionButton = formElement.querySelector(".button--next-question");
  const renewClickEventListener = memorizedEventListenerReNewer(nextQuestionButton, "click");
  return (response) => {
    nextQuestionButton.classList.remove("hidden");
    renewClickEventListener(() => {
      removeChildren(explanationElement);
      explanationElement.classList.add("hidden");
      nextQuestionButton.classList.add("hidden");
      renderQuestion(formElement, response);
    });
  };
};
export const resultButtonRenderer = (formElement) => {
  const helpLink = formElement.dataset["helpLink"];
  const explanationElement = formElement.querySelector(".quiz-form__explanation");
  const resultButton = formElement.querySelector(".button--result");
  const renewClickEventListener = memorizedEventListenerReNewer(resultButton, "click");
  return (response) => {
    resultButton.classList.remove("hidden");
    renewClickEventListener(() => {
      removeChildren(explanationElement);
      explanationElement.classList.add("hidden");
      resultButton.classList.add("hidden");
      renderSuccess(formElement, response);
    });
    response.quizResponseText = response.quizResponseText.replace("␟", helpLink);
  };
};
